import { retrieveProducts as apiRetrieveProducts } from '@/api/api'

export default {

  RETRIEVE_PRODUCTS: ({ commit }) => {
    return apiRetrieveProducts().then(responseData => {
      commit('SET_PRODUCTS', { products: responseData.response.data })
    }).catch(error => Promise.reject(error.response.data))
  }
}
